module.exports = __webpack_public_path__ + "static/media/c4_1.71445ab9.png";